import MultipleDropdown from './MultipleDropdown';

export default MultipleDropdown;
